import _asyncToGenerator from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.filter.js";
/**
 * Return global action names and descriptions.
 *
 * @param dispatch
 * @param commit
 * @returns {*}
 */
export function getActions(_ref) {
  var dispatch = _ref.dispatch,
    commit = _ref.commit;
  return dispatch('api', {
    url: 'actions'
  }, {
    root: true
  }).then(function (response) {
    commit('SET_ARRAY', {
      state: 'actions',
      data: response.data.data
    });
  });
}

/**
 * Get Model actions.
 *
 * @param dispatch
 * @param commit
 * @param payload
 * @returns {*}
 */
export function getModelActions(_ref2, payload) {
  var dispatch = _ref2.dispatch,
    commit = _ref2.commit;
  return dispatch('api', {
    url: 'concept-actions/' + payload.id + '/model-actions',
    params: payload.params
  }, {
    root: true
  });
}

/**
 * Get actions that are not committed yet.
 *
 * @param dispatch
 * @param getters
 * @param commit
 * @param payload
 * @returns {*}
 */
export function getNotCommittedActions(_ref3, payload) {
  var dispatch = _ref3.dispatch,
    commit = _ref3.commit,
    getters = _ref3.getters;
  return dispatch('api', {
    url: 'concept-actions',
    params: {
      page: payload.page,
      limit: 20,
      committed: 0,
      personal: 1,
      include: 'action,entity',
      includeCount: 'modelActions'
    }
  }, {
    root: true
  }).then(function (response) {
    commit('SET_ARRAY', {
      state: 'notCommittedActions',
      data: response.data.data.map(function (item) {
        return {
          id: item.id,
          action: item.action,
          actionDescription: item.action.description,
          model: item.model,
          modelName: item.model.substring(4),
          modelId: item.model_id,
          entityName: item.entity.name,
          modelActionsCount: item.model_actions_count,
          approved: item.approved,
          details: item.details
        };
      })
    });
    commit('SET', {
      state: 'notCommittedActionsMeta',
      data: response.data.meta
    });
  });
}

/**
 * Get all available actions by name.
 *
 * @param dispatch
 * @param commit
 * @param name
 * @returns {*}
 */
export function getAllActionsByName(_ref4, name) {
  var dispatch = _ref4.dispatch,
    commit = _ref4.commit;
  return dispatch('api', {
    url: 'concept-actions',
    params: {
      all: 1,
      name: name
    }
  }, {
    root: true
  });
}

/**
 * Create ana actual action based on selected data.
 *
 * @param dispatch
 * @param commit
 * @param {Object} payload
 * @param {string} payload.tableModel
 * @param {number[]} payload.tableModelIds
 * @param {string} payload.targetModel
 * @param {number} payload.targetModelId
 * @param {number} payload.actionId
 * @param {string} payload.details
 * @returns {*}
 */
export function applyAction(_ref5, payload) {
  var dispatch = _ref5.dispatch,
    commit = _ref5.commit;
  var data = {
    table_model: payload.tableModel,
    table_model_ids: payload.tableModelIds,
    target_model: payload.targetModel,
    target_model_id: payload.targetModelId,
    action_id: payload.actionId,
    details: payload.details
  };
  if (payload.secondaryActionId) {
    data.secondary_action_id = payload.secondaryActionId;
  }
  return dispatch('api', {
    method: 'post',
    url: 'concept-actions',
    data: data
  }, {
    root: true
  });
}

/**
 * Approve or reject an action.
 *
 * @param dispatch
 * @param payload
 * @returns {*}
 */
export function resolveAction(_ref6, payload) {
  var dispatch = _ref6.dispatch;
  return dispatch('api', {
    method: 'put',
    url: 'concept-actions/resolve/' + payload.id,
    data: {
      approve: payload.approve,
      delete_related: payload.deleteRelated
    }
  }, {
    root: true
  });
}

/**
 * Delete model action. AKA Undo.
 *
 * @param dispatch
 * @param commit
 * @param {Object} payload
 * @param {number} payload.id Concept action ID
 * @param {Array} payload.modelActionIds
 * @param {boolean} payload.deleteRelated
 * @returns {*}
 */
export function deleteModelAction(_ref7, payload) {
  var dispatch = _ref7.dispatch,
    commit = _ref7.commit;
  return dispatch('api', {
    method: 'put',
    url: 'concept-actions/' + payload.id + '/model-actions/delete',
    data: {
      model_action_ids: payload.modelActionIds,
      delete_related: payload.deleteRelated
    }
  }, {
    root: true
  }).then(function (response) {
    commit('audits/SET_ACTION', response.data.data, {
      root: true
    });
  });
}

/**
 * Soft delete action.
 *
 * @param dispatch
 * @param commit
 * @param {Object} payload
 * @param {number} payload.id
 * @param {string} payload.comment
 * @param {string} payload.flag
 * @param {number} payload.deleteRelated | 1/0
 * @returns {*}
 */
export function deleteAction(_ref8, payload) {
  var dispatch = _ref8.dispatch,
    commit = _ref8.commit;
  var actionId = payload.id;
  return dispatch('api', {
    method: 'put',
    url: 'concept-actions/delete/' + actionId,
    data: {
      comment: payload.comment,
      flag: payload.flag,
      delete_related: payload.deleteRelated
    }
  }, {
    root: true
  }).then(function (response) {
    commit('audits/SET_ACTION_AS_DELETED', actionId, {
      root: true
    });
    return response;
  });
}

/**
 * Resolve (Commit/dismiss) actions.
 *
 * @param dispatch
 * @param commit
 * @param {string} actions - Stringified collection of actions to be committed.
 * @param {number[]} actionIds - Array of IDs for the REMOVE_FROM_ARRAY mutation
 * @param {string} endpoint - can be either 'commit' or 'destroy'
 * @returns {*}
 */
export function resolveActions(_ref9, _ref10) {
  var dispatch = _ref9.dispatch,
    commit = _ref9.commit;
  var actions = _ref10.actions,
    actionIds = _ref10.actionIds,
    endpoint = _ref10.endpoint;
  return dispatch('api', {
    method: 'put',
    url: "concept-actions/".concat(endpoint),
    data: {
      concept_actions: actions
    }
  }, {
    root: true
  }).then(function () {
    commit('REMOVE_FROM_ARRAY', {
      state: 'notCommittedActions',
      key: 'id',
      targets: actionIds
    });
  });
}

/**
 * Prepare the state for the multi-detach action over the items from the selected nGram's concept.
 *
 * @deprecated
 * @param dispatch
 * @param getters
 * @param rootGetters
 * @param commit
 * @param {string} actionName
 * @returns {*}
 */
export function applyMultiDetachActions(_x, _x2) {
  return _applyMultiDetachActions.apply(this, arguments);
}
function _applyMultiDetachActions() {
  _applyMultiDetachActions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref11, _ref12) {
    var dispatch, getters, rootGetters, commit, actionName, selectedConcept, nGrams, concept, content, action, nGram;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dispatch = _ref11.dispatch, getters = _ref11.getters, rootGetters = _ref11.rootGetters, commit = _ref11.commit;
          actionName = _ref12.actionName;
          selectedConcept = rootGetters['conceptDetach/selectedConcept'];
          nGrams = rootGetters['conceptDetach/nGrams'];
          concept = rootGetters['conceptDetach/concept'];
          content = rootGetters['conceptDetach/content'];
          action = getters['actionByName'](actionName);
          nGram = nGrams.find(function (n) {
            return n.name === selectedConcept.term;
          });
          if (nGram && nGram[concept + 's'] && nGram[concept + 's'].length) {
            commit('SET', {
              state: 'multiDetach',
              data: {
                nGram: selectedConcept.term,
                data: {
                  actionId: action.id,
                  tableModel: concept + '_' + content,
                  tableModelIds: 'all',
                  targetModel: concept,
                  targetModelId: 0,
                  details: JSON.stringify({
                    term: selectedConcept.term,
                    flag: selectedConcept.flag
                  })
                },
                index: 0,
                items: nGram[concept + 's'].filter(function (cui) {
                  return cui.progress_completed < cui.progress_total;
                })
              }
            });
          }
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _applyMultiDetachActions.apply(this, arguments);
}